<template>
  <div class="event-tip-popup">
    <div class="event-tip-popup-shade"></div>
    <div class="event-tip-popup-content">
      <p class="event-tip-popup-text">{{ letter.eventBindSucc }}</p>
      <p class="event-tip-popup-text big">{{ letter.eventGainCoupon }}</p>
      <div class="btn" @click="showCouponPopup">
        {{ letter.eventLookCoupon }}
      </div>
      <a
        class="event-tip-popup-close j-click-tip-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>
    
<script type="text/javascript">
import { UPDATE_LOADING } from '@store/officialStore';
export default {
  name: 'eventBindSuccPopup',
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closePopup');
    },
    sureBind() {
      this.$emit('sureBind');
    },
    showCouponPopup() {
      const self = this;
      this.$store.commit(UPDATE_LOADING, true);
      setTimeout(() => {
        self.$store.commit(UPDATE_LOADING, false);
        this.$emit('showGameCoupon');
        this.hidePopup();
      }, 3000);
    }
  },
  components: {}
};
</script>
    
    <style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';

.event-tip-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 998;
  width: 100%;
  height: 100%;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  &-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 52px;
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('event-bind-popup.png');
  }

  &-text {
    font-size: 36px;
    color: var(--event-popup-bind-text);
    text-align: center;
    width: 100%;
    &.big {
      font-size: 48px;
      margin-top: 10px;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    font-size: 36px;
    color: var(--global-tip-popup-btn);
    cursor: pointer;
    margin-top: 50px;
    @psetbg ('look-coupon.png');
  }

  &-close {
    position: absolute;
    right: 31px;
    top: 30px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
@media screen and (orientation: landscape) {
  .event-tip-popup {
    &-close {
      position: absolute;
      @psetbg ('close-hen.png');
    }
    .btn {
      font-size: 24px;
    }
  }
}
</style>
    